import * as React from 'react';
import {FunctionComponent} from 'react';
import {styled} from '../../theme';
import {BoatProgressWithCombinations} from '../../../business/boats/boats_with_progress_and_combinations_provider';
import {formatFinishTimeMs} from '../../../support/format_finish_time';

interface OwnProps {
    boatWithCombination: BoatProgressWithCombinations;
}

const ProgressRow = styled.div`
    margin: -10px -10px 10px;
    padding: 5px 10px;
    background: #7c7c7c;
    color: #ffffff;
`;

const InfoBadge = styled.span`
    background: #193f49;
    display: inline-block;
    padding: 0.5em 0.8em;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
    margin-right: 0.5em;
`;

export const BoatProgressRow: FunctionComponent<OwnProps> = ({boatWithCombination}) => {
    return (
        <ProgressRow>
            {boatWithCombination.boat.preliminaryFinishTimeMillis === null ? (
                <InfoBadge>Distance: {Math.round(boatWithCombination.boat.distanceMeters * 10) / 10 + 'm'}</InfoBadge>
            ) : null}
            {boatWithCombination.boat.preliminaryFinishTimeMillis !== null &&
            boatWithCombination.boat.definitiveFinishTimeMillis === null ? (
                <InfoBadge>Gathering race data</InfoBadge>
            ) : null}
            {boatWithCombination.boat.definitiveFinishTimeMillis && (
                <InfoBadge>{formatFinishTimeMs(boatWithCombination.boat.definitiveFinishTimeMillis)}</InfoBadge>
            )}
        </ProgressRow>
    );
};
